import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { Container as TopStoryContainer } from "~/components/content/content-item-render/variants/olympics-top-story/styles";

export const Container = styled.div`
  padding-inline: 20px;
`;

export const Header = styled.div`
  margin-block-end: 8px;

  color: #000000;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;

  opacity: 0.5;
`;

export const TopStories = styled.div`
  ${TopStoryContainer} {
    border-block-end: 1px solid rgba(0, 0, 0, 0.1);
    &:not(:last-child) {
      margin-block-end: 16px;
    }
  }
`;
